module.exports = __webpack_public_path__ + "img/bg.0cb00c38.png";